import { render, staticRenderFns } from "./ServiceListOld.vue?vue&type=template&id=1d895bd5&scoped=true"
import script from "./ServiceListOld.vue?vue&type=script&lang=js"
export * from "./ServiceListOld.vue?vue&type=script&lang=js"
import style0 from "./ServiceListOld.vue?vue&type=style&index=0&id=1d895bd5&prod&lang=stylus&scoped=true"
import style1 from "./ServiceListOld.vue?vue&type=style&index=1&id=1d895bd5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d895bd5",
  null
  
)

export default component.exports